import _ from 'lodash';
import { Node } from 'tiptap';
import { setBlockType, toggleBlockType } from 'tiptap-commands';
import { nodeIsActive } from 'tiptap-utils';
import {
  TextFormattingNodeSpec,
  getTextFormattingNodeAttrs,
  getTextFormattingDOM,
} from './TextFormattingNode';

function getAttrs(dom) {
  const attrs = getTextFormattingNodeAttrs(dom);
  return attrs;
}

function toDOM(node) {
  const dom = getTextFormattingDOM(node);
  return dom;
}

export default class DMParagraph extends Node {
  get name() {
    return 'paragraph';
  }

  get schema() {
    return {
      ...TextFormattingNodeSpec,
      attrs: {
        ...TextFormattingNodeSpec.attrs,
      },
      content: 'inline*',
      group: 'block',
      draggable: false,
      parseDOM: [
        { tag: 'p', getAttrs },
      ],
      toDOM,
    };
  }

  commands({ type }) {
    return (attrs) => (state, dispatch, view) => {
      const { selection } = state;
      const position = selection.$cursor
        ? selection.$cursor.pos
        : selection.$to.pos;
      const $pos = state.doc.resolve(position);
      const $parent = $pos.parent;
      const updateAttrs = $parent ? _.clone($parent.attrs) : {};

      Object.assign(updateAttrs, attrs);

      const isActive = nodeIsActive(state, type, attrs);

      if (isActive) {
        return setBlockType(toggleBlockType)(state, dispatch, view);
      }

      return setBlockType(type, updateAttrs)(state, dispatch, view);
    };
  }
}
